export default "__VITE_ASSET__C8$KLTcU__"